import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { Store } from '@ngrx/store';
import { ApplicationState } from '../../../store/reducers';
import { getRecoveryMethodError } from '../../../store/reducers/index';
import * as RecoveryMethodsActions from '../../store/actions/password-recovery-management.actions';
import { Subscription } from 'rxjs';

@Component({
  selector: 'mprd-mobile-add-container',
  templateUrl: 'mobile-add-container.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MobileAddContainerComponent implements OnInit, OnDestroy {
  showAddNumber: boolean;
  showLoadingSpinner: boolean;
  $getRecoveryMethodError: Subscription;

  constructor(
    private store: Store<ApplicationState>,
    private changeDetector: ChangeDetectorRef,
  ) {}

  ngOnInit() {
    this.$getRecoveryMethodError = this.store
      .select(getRecoveryMethodError)
      .subscribe(() => {
        this.showLoadingSpinner = false;
        this.changeDetector.markForCheck();
      });
  }

  ngOnDestroy() {
    this.$getRecoveryMethodError.unsubscribe();
  }

  onMobileNumberSubmitFormStatusAndValue(mobileNumberSubmitFormStatusAndValue: {
    mobileNumberSubmitFormStatus: string;
    mobileNumber: string;
    errors: any;
  }) {
    this.showLoadingSpinner = true;
    this.store.dispatch(
      new RecoveryMethodsActions.SetSmsRecoveryMethodAction(
        mobileNumberSubmitFormStatusAndValue.mobileNumber,
      ),
    );
  }

  onMobileNumberSubmitCancel() {
    this.toggleShowAddNumber();
  }

  public toggleShowAddNumber() {
    this.showAddNumber = !this.showAddNumber;
  }
}
